export const robots = [
    {
        id: 1,
        name: 'Hellen',
        email: 'hellen@qoogle.com'
    },
    {
        id: 2,
        name: 'Rohan',
        email: 'rohan@qoogle.com'
    },
    {
        id: 3,
        name: 'Sid',
        email: 'sid@qoogle.com'
    },
    {
        id: 4,
        name: 'Virat',
        email: 'virat@qoogle.com'
    },
    {
        id: 5,
        name: 'Sachin',
        email: 'sachin@qoogle.com'
    },
    {
        id: 6,
        name: 'Yuvraj',
        email: 'yuvraj@qoogle.com'
    },
    {
        id: 7,
        name: 'Shikhar',
        email: 'shikhar@qoogle.com'
    },
    {
        id: 8,
        name: 'Raina',
        email: 'raina@qoogle.com'
    },
    {
        id: 9,
        name: 'David',
        email: 'david@qoogle.com'
    },
    {
        id: 10,
        name: 'Krish',
        email: 'krish@qoogle.com'
    }
];